import { observable, action } from 'mobx';
import agent from '../../api/agent';
import navigatorStore from '../navigatorStore'
class ArtworkStore {

    @action getInitialArtworksByCategory(query,hide) {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.CategoryArtworks.getArtworksByCategory(query, { limit: 4, offset: 0 },hide)
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                //   navigatorStore.openErrorModal(err);
            }))
    }

    @action getBrowseAllCategoryArtworks(query, hide) {
        return agent.CategoryArtworks.getBrowseAllArtworks(query, {limit: 4, offset: 0}, hide)
            .catch(action(err => {

            }))
    }


    @action getInitialArtworksByCategoryPublic(query) {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.CategoryArtworks.getArtworksByCategoryPublic(query, { limit: 4, offset: 0 })
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                //   navigatorStore.openErrorModal(err);
            }))
    }

    @action getRecentArtworks() {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.CategoryArtworks.getRecentArtworks({ limit: 4, offset: 0 })
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                //   navigatorStore.openErrorModal(err);
            }))
    }
    @action getRecentArtworksPublic() {
        // console.log(this.paginationOffset)
        // let queryString = querystring.stringify({limit : this.paginationLimit ,offset : this.paginationOffset });
        return agent.CategoryArtworks.getRecentArtworksPublic({ limit: 4, offset: 0})
            .catch(action(err => {
                // this.commentErrors = err.response && err.response.body && err.response.body.errors;
                //   navigatorStore.openErrorModal(err);
            }))
    }


}
export default new ArtworkStore();


// WEBPACK FOOTER //
// ./src/stores/artworksStores/landingPageArtworksStore.js